import React, { Component } from 'react';
import FakeData from '../../fake-data';
import { Link } from 'react-router-dom';
import { Helmet } from "react-helmet";
import './TeamInit.css';
import { ItemPicker, Modal, PhonePicker } from '../../components/Common';
import { CountryDropdown, RegionDropdown } from 'react-country-region-selector';
import { LocationPicker } from '../../components/Event';

export default class TeamInit extends Component {
    constructor(p) {
        super(p)
        this.state = {
            team: {
                name: "",
                level: "",
                sport: "",
                id: null,
                hash: null,
                email: "",
                phone: "",
                land: "",
                website: "",
                location: "",
                address: "",
                suburb: "",
                postal: "",
                state: "",
                country: "",
                ground: "",
                activeSquad: {
                    entry: 1,
                    age: "",
                    name: "",
                    gender: "",
                    coach: {
                        id: null,
                        name: ""
                    },
                    assCoach: {
                        id: null,
                        name: ""
                    },
                    coachErr: false,
                    assCoachErr: false
                },
                squads: [],
                socials: [],
                established: "",
                manager: { id: null, name: "" },
                secretary: { id: null, name: "" },
                about: "",
                otherPeople: [],
                settings: []
            },
            yourRole: {
                role: ""
            },
            confirmee: {
                name: "",
                email: ""
            },
            othersVerifications: [],
            levels: ["Amatuer", "Professional", "Semi-Professional"],
            genders: ["male", "female", "mixed"],
            roles: ["Captain", "Coach", "Manager", "Player", "Referee", "Staff"],
            isAddingSports: false,
            isAddingTeams: false,
            isAddingPersons: false,
            canAddTeams: false,
            isAfterReg: false,
            phoneErr: false,
            landErr: false
        }
    }

    componentWillMount() {
        if (FakeData.getData("teamStore")) {
            const data = FakeData.getData("teamStore");
            this.state.team.name = data.name;
            this.state.team.sport = data.sport
            this.setState({
                team: this.state.team
            });
        }
    }

    onPhoneChange(num, err) {
        this.state.team.phone = num
        this.setState({ team: this.state.team, phoneErr: err });
    }

    onLandlineChange(num, err) {
        this.state.team.land = num
        this.setState({ team: this.state.team, landErr: err });
    }

    save() {
        const team = this.state.team;
        const _teams = this.getTeamNames();
        if (team.name === "" || FakeData.inArray(this.state.team.name.toLowerCase(),_teams)) {
            this.setState({ nameErr: true });
            return;
        }

        if (team.level === "") {
            this.setState({ levelErr: true });
            return;
        }

        if (team.activeSquad.age === "") {
            this.setState({ ageErr: true });
            return;
        }

        if (this.state.yourRole.role === "") {
            this.setState({ roleErr: true });
            return;
        }

        if (team.email === "" || !FakeData.isEmail(team.email)) {
            this.setState({ emailErr: true });
            return;
        }

        if (team.phone === "" || this.state.phoneErr) {
            this.setState({ phoneErr: true });
            return;
        }

        if (team.land === "" || this.state.landErr) {
            this.setState({ landErr: true });
            return;
        }

        if (team.website === "" || !FakeData.isWebsite(team.website)) {
            this.setState({ webErr: true });
            return;
        }

        if (team.sport === "") {
            this.setState({ sportErr: true });
            return;
        }

        if (team.activeSquad.gender === "") {
            this.setState({ genderErr: true });
            return;
        }

        if (team.ground === "") {
            this.setState({ groundErr: true });
            return;
        }

        if (team.address === "") {
            this.setState({ addressErr: true });
            return;
        }

        if (team.suburb === "") {
            this.setState({ suburbErr: true });
            return;
        }

        if (team.location === "") {
            this.setState({ locationErr: true });
            return;
        }

        if (team.postal === "") {
            this.setState({ postalErr: true });
            return;
        }

        if (team.country === "") {
            this.setState({ countryErr: true });
            return;
        }

        if (team.state === "") {
            this.setState({ stateErr: true });
            return;
        }

        if (team.activeSquad.coach.id === null) {
            this.setState({ managerErr: true });
            return;
        }

        if (team.activeSquad.assCoach.id === null) {
            this.setState({ secretaryErr: true });
            return;
        }

        if (this.state.confirmee.name === "") {
            this.setState({ confirmeeNameErr: true });
            return;
        }

        if (this.state.confirmee.email === "" || !FakeData.isEmail(this.state.confirmee.email)) {
            this.setState({ confirmeeEmailErr: true });
            return;
        }

        const others = this.state.othersVerifications

        /*if ((this.state.yourRole.role === "Admin" || this.state.yourRole.role === "Staff") && (this.state.othersVerifications.length === 0)) {
            //console.log(this.state.yourRole.role, this.state.othersVerifications.length)
            this.setState({ needRoles: false });
        } else {
            this.setState({ needRoles: true });
            return;
        }*/

        let bool = false;
        for (let x = 0; x < others.length; x++) {
            let item = others[x];
            if (item.name === "") {
                item.nameError = true;
                this.setState({ othersVerifications: others });
                bool = true;
            }

            if (item.email === "" || !FakeData.isEmail(item.email)) {
                item.emailErr = true;
                this.setState({ othersVerifications: others });
                bool = true;
            }
        }

        if (bool) {
            return;
        }

        const _that = this;

        team['username'] = team.name.replace(" ","_").toLowerCase();
        this.setState({ team: team });
        const dataTo = {
            team: team,
            confirmee: this.state.confirmee,
            role: this.state.yourRole,
            otherPeople: others,
            user: FakeData.getData("yoo")
        }

        //console.log(dataTo)
        FakeData.post("/createTeamWithSquad.php?auth0", dataTo, {
            success: ((res) => {
                if (res.error) {
                    FakeData.alert("A team with the email or name provided already exists!");
                    _that.setState({ emailErr: true });
                } else {
                    _that.state.team.id = res.id;
                    _that.state.team.hash = res.hash;
                    _that.setState({ isAfterReg: true, team: _that.state.team });
                }
            }),
            error: ((err) => {

            })
        }, true, "Team was created!", ((e) => { }))
    }

    getAges() {
        const list = [];
        for (let x = 7; x < 19; x++) {
            list.push("Under " + x);
        }

        list.push("Seniors")
        list.push("Mixed")

        return list;
    }

    getTeamNames = () => {
        const _teams = FakeData.getData("all_teams");
        const names = [];
        const rawNames = _teams.map((item, i)=>{
            return FakeData.nullify(item.rawName).toLowerCase();
        });

        const teamName = _teams.map((item, i)=>{
            return FakeData.nullify(item.name).split("(")[0].toLowerCase();
        });

        return names.concat(teamName, rawNames);
    }

    render() {
        const _teams = this.getTeamNames();
        return (
            <div className="full-screen-page">
                {!this.state.isAfterReg &&
                    <div className="after-register-profile" style={{ width: "85%" }}>
                        <div className="after-register-profile-content">
                            <div className="after-register-profile-content-head">
                                <img src="images/add_blu.svg" />
                                <h1>Team Profile</h1>
                            </div>
                            <div className="after-register-profile-content-body">
                                <div className="register-profile-content-body-item">
                                    <h2>Team Details</h2>
                                    <div>
                                        <input placeholder="Team Name" className={(this.state.nameErr) ? "error" : FakeData.inArray(this.state.team.name.toLowerCase(),_teams)?"error": ""} value={this.state.team.name} onChange={(e) => {
                                            const val = e.target.value
                                            this.state.team.name = val;
                                            this.setState({ team: this.state.team, nameErr: FakeData.inArray(val.toLowerCase(),_teams)?true:false });
                                        }} />
                                        <select className={(this.state.levelErr) ? "error" : ""} onChange={(e) => {
                                            const val = e.target.value
                                            this.state.team.level = val;
                                            this.setState({ team: this.state.team, levelErr: false });
                                        }} value={this.state.team.level}>
                                            <option value="" disabled={true} style={{ padding: "10px" }}>Team professional level?</option>
                                            {
                                                this.state.levels.map((item, i) => {
                                                    return (
                                                        <option value={item} key={i} style={{ padding: "10px" }}>{item}</option>
                                                    )
                                                })
                                            }
                                        </select>
                                        <select className={(this.state.ageErr) ? "error" : ""} onChange={(e) => {
                                            const val = e.target.value
                                            this.state.team.activeSquad.age = val;
                                            this.setState({ team: this.state.team, ageErr: false });
                                        }} value={this.state.team.activeSquad.age}>
                                            <option value="" disabled={true} style={{ padding: "10px" }}>Age Group?</option>
                                            {
                                                this.getAges().map((item, i) => {
                                                    return (
                                                        <option value={item} key={i} style={{ padding: "10px" }}>{item}</option>
                                                    )
                                                })
                                            }
                                        </select>
                                        <select className={(this.state.roleErr) ? "error" : ""} onChange={(e) => {
                                            const val = e.target.value
                                            this.state.yourRole.role = val;
                                            this.setState({ yourRole: this.state.yourRole, roleErr: false });
                                        }} value={this.state.yourRole.role}>
                                            <option value="" disabled={true} style={{ padding: "10px" }}>What is your role in the team?</option>
                                            {
                                                this.state.roles.map((item, i) => {
                                                    return (
                                                        <option value={item} key={i} style={{ padding: "10px" }}>{item}</option>
                                                    )
                                                })
                                            }
                                        </select>
                                        <div className="register-input">
                                            <img src="images/email_icon_blu.svg" />
                                            <input className={(this.state.emailErr) ? "error" : ""} placeholder="teamname@teamwebsite.com" value={this.state.team.email} onChange={(e) => {
                                                const val = e.target.value
                                                this.state.team.email = val;
                                                this.setState({ team: this.state.team, emailErr: !FakeData.isEmail(val) });
                                            }} />
                                        </div>
                                        <div className="register-input">
                                            <img src="images/mobile_icon_blu.svg" />
                                            <PhonePicker className={(this.state.phoneErr) ? "error" : ""} value={this.state.team.phone} onChange={this.onPhoneChange.bind(this)} />
                                        </div>
                                        <div className="register-input">
                                            <img src="images/landline_icon_blu.svg" />
                                            <PhonePicker className={(this.state.landErr) ? "error" : ""} value={this.state.team.land} onChange={this.onLandlineChange.bind(this)} />
                                        </div>
                                        <div className="register-input">
                                            <img src="images/website_icon_blu.svg" />
                                            <input className={(this.state.webErr) ? "error" : ""} placeholder="www.teamwebsite.com" value={this.state.team.website} onChange={(e) => {
                                                const val = e.target.value
                                                this.state.team.website = val;
                                                this.setState({ team: this.state.team, webErr: !FakeData.isWebsite(val) });
                                            }} />
                                        </div>
                                    </div>
                                </div>
                                <div className="register-profile-content-body-item">
                                    <h2>Information</h2>
                                    <div>
                                        <select className={(this.state.sportErr) ? "error" : ""} onChange={(e) => {
                                            const val = e.target.value
                                            this.state.team.sport = val;
                                            this.setState({ team: this.state.team, sportErr: false });
                                        }} value={this.state.team.sport}>
                                            <option value="" disabled={true} style={{ padding: "10px" }}>Select sport</option>
                                            {
                                                FakeData.listify(FakeData.getData("all_sports")).map((item, i) => {
                                                    return (
                                                        <option value={item.name} key={i} style={{ padding: "10px" }}>{item.name}</option>
                                                    )
                                                })
                                            }
                                        </select>
                                        <select className={(this.state.genderErr) ? "error" : ""} onChange={(e) => {
                                            const val = e.target.value
                                            this.state.team.activeSquad.gender = val;
                                            this.setState({ team: this.state.team, genderErr: false });
                                        }} value={this.state.team.activeSquad.gender}>
                                            <option value="" disabled={true} style={{ padding: "10px" }}>Select gender</option>
                                            {
                                                this.state.genders.map((item, i) => {
                                                    return (
                                                        <option value={item} key={i} style={{ padding: "10px" }}>{item.capitalize()}</option>
                                                    )
                                                })
                                            }
                                        </select>
                                        <LocationPicker classes={(this.state.groundErr) ? "add-team-location-pk error" : "add-team-location-pk"} value={(this.state.team.ground !== "") ? this.state.team.ground : "Home ground"} user={FakeData.getData("yoo")} places={(FakeData.getData("yoo") && FakeData.getData("yoo").placesLived) ? FakeData.getData("yoo").placesLived.others : []} onSetPlace={(data) => {
                                            this.state.team.ground = data
                                            this.setState({
                                                team: this.state.team,
                                                groundErr: false
                                            });
                                        }} />
                                        <div className="register-input">
                                            <img src="images/location_icon.svg" />
                                            <input className={(this.state.addressErr) ? "error" : ""} placeholder="Address" value={this.state.team.address} onChange={(e) => {
                                                const val = e.target.value
                                                this.state.team.address = val;
                                                this.setState({ team: this.state.team, addressErr: false });
                                            }} />
                                        </div>
                                        <div className="register-input">
                                            <img src="" />
                                            <input className={(this.state.suburbErr) ? "error" : ""} placeholder="Suburb" value={this.state.team.suburb} onChange={(e) => {
                                                const val = e.target.value
                                                this.state.team.suburb = val;
                                                this.setState({ team: this.state.team, suburbErr: false });
                                            }} />
                                        </div>
                                        <div className="register-input">
                                            <img src="" />
                                            <input className={(this.state.locationErr) ? "error" : ""} placeholder="City" value={this.state.team.location} onChange={(e) => {
                                                const val = e.target.value
                                                this.state.team.location = val;
                                                this.setState({ team: this.state.team, locationErr: false });
                                            }} />
                                        </div>
                                        <div className="register-input">
                                            <img src="" />
                                            <input type="number" max="99999" className={(this.state.postalErr) ? "error" : ""} placeholder="Postal Code" value={this.state.team.postal} onChange={(e) => {
                                                const val = e.target.value
                                                this.state.team.postal = val;
                                                this.setState({ team: this.state.team, postalErr: false });
                                            }} />
                                        </div>
                                        <div className="register-input">
                                            <img src="" />
                                            <CountryDropdown classes={(this.state.countryErr) ? "select-input error" : "select-input"}
                                                value={this.state.team.country}
                                                onChange={(val) => {
                                                    this.state.team.country = val;
                                                    this.setState({ team: this.state.team, countryErr: false });
                                                }} />
                                        </div>
                                        <div className="register-input">
                                            <img src="" />
                                            <RegionDropdown classes={(this.state.stateErr) ? "select-input error" : "select-input"}
                                                country={this.state.team.country}
                                                value={this.state.team.state}
                                                onChange={(val) => {
                                                    this.state.team.state = val;
                                                    this.setState({ team: this.state.team, stateErr: false });
                                                }} />
                                        </div>
                                    </div>
                                </div>
                                <div className="register-profile-content-body-item">
                                    <h2>Team Management</h2>
                                    <div>
                                        <ItemPicker label="Team Coach" user={FakeData.getData("yoo")} error={this.state.managerErr} onSelectedItem={(user) => {
                                            this.state.team.activeSquad.coach = user;
                                            this.setState({ team: this.state.team, managerErr: false });
                                        }} width="27.85em" isExtended={true} data={(FakeData.getData("yoo")) ? FakeData.getData("yoo").friends : []} />
                                        <br />
                                        <ItemPicker label="Team Ass. Coach" user={FakeData.getData("yoo")} error={this.state.secretaryErr} onSelectedItem={(user) => {
                                            this.state.team.activeSquad.assCoach = user;
                                            this.setState({ team: this.state.team, secretaryErr: false });
                                        }} width="27.85em" isExtended={true} data={(FakeData.getData("yoo")) ? FakeData.getData("yoo").friends : []} />
                                    </div>
                                    <h2>Confirmation</h2>
                                    <div>
                                        <p>To Confirm that <b>{(this.state.team.name === "") ? "this team" : this.state.team.name}</b> does exist please enter at least one person’s name from one of the sports teams that make up the teams at the team.</p>
                                        <input className={(this.state.confirmeeNameErr) ? "error" : ""} placeholder="Name" value={this.state.confirmee.name} onChange={(e) => {
                                            const val = e.target.value
                                            this.state.confirmee.name = val;
                                            this.setState({ confirmee: this.state.confirmee, confirmeeNameErr: false });
                                        }} />
                                        <div className="register-input">
                                            <img src="images/email_icon_blu.svg" />
                                            <input className={(this.state.confirmeeEmailErr) ? "error" : ""} placeholder="name@example.com" value={this.state.confirmee.email} onChange={(e) => {
                                                const val = e.target.value
                                                this.state.confirmee.email = val;
                                                this.setState({ confirmee: this.state.confirmee, confirmeeEmailErr: !FakeData.isEmail(val) });
                                            }} />
                                        </div>
                                        <p className={this.state.needRoles ? "error" : ""}>If you have selected your role as <b>Team Manager, Coach, Referee or Score keeper</b> you will need to be verified by an additional person. This is important, non-verification of your role will mean you cannot create games or access the Game Management console (GMC).</p>
                                        <div>
                                            {
                                                this.state.othersVerifications.map((item, i) => {
                                                    return (
                                                        <div key={i} className="verify-input">
                                                            <input placeholder="Name" className={(item.nameError) ? "error" : ""} value={item.name} onChange={(e) => {
                                                                const val = e.target.value
                                                                item.name = val;
                                                                item.nameError = false
                                                                this.setState({ othersVerifications: this.state.othersVerifications });
                                                            }} />
                                                            <div className="register-input">
                                                                <img src="images/email_icon_blu.svg" />
                                                                <input className={(item.emailErr) ? "error" : ""} placeholder="name@example.com" value={item.email} onChange={(e) => {
                                                                    const val = e.target.value
                                                                    item.email = val;
                                                                    item.emailErr = !FakeData.isEmail(val)
                                                                    this.setState({ othersVerifications: this.state.othersVerifications });
                                                                }} />
                                                                <i className="material-icons" onClick={() => {
                                                                    this.state.othersVerifications.splice(i, 1)
                                                                    this.setState({ othersVerifications: this.state.othersVerifications });
                                                                }}>delete</i>
                                                            </div>
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                        <div className="profile_add_item_alt" onClick={() => {
                                            if ((this.state.yourRole.role === "Admin" || this.state.yourRole.role === "Staff" || this.state.yourRole.role === "")) {
                                                return;
                                            } else if ((this.state.othersVerifications[this.state.othersVerifications.length - 1] && (this.state.othersVerifications[this.state.othersVerifications.length - 1].name === "" || this.state.othersVerifications[this.state.othersVerifications.length - 1].email === ""))) {
                                                return
                                            }
                                            this.state.othersVerifications.push({ name: "", nameError: false, email: "", emailErr: false })
                                            this.setState({ othersVerifications: this.state.othersVerifications, needRoles: false });
                                        }}>Add a verification contact</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div tabIndex="0" className="after-register-profile-button gbl-btn" onClick={this.save.bind(this)}>Save Profile</div>
                    </div>
                }
                {this.state.isAfterReg &&
                    <div className="after-register-profile" style={{ width: "85%" }}>
                        <div className="after-reg">
                            <h3>Team page created successfully!</h3>
                            <Link  to={{ pathname: "/team/" + this.state.team.username, search: '?sInit=about' }}>Continue to Team Page</Link>
                        </div>
                    </div>
                }
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/pages/CreatePages/TeamInit.jsx